import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import browserHistory from 'react-router/lib/browserHistory';
import CSSModules from 'react-css-modules';
import Button from '../Button';
import { AUTH, COMMON } from '../../constants/strings';
import { HEALTHBOARD } from '../../constants/routes';
import styles from './index.styl';
import MetaHelmet from '../AppHelmet/MetaHelmet';
import { usePageView } from '../../hocs/usePageView';

const AccessDenied = ({ forwardRoute }) => {
  usePageView('Access Denied');
  return (
    <div styleName="formWrapper">
      <MetaHelmet title="pages.title.accessDenied" />

      <p styleName="formTitle">
        <FormattedMessage {...AUTH.titles.accessDenied} />
      </p>
      <p styleName="formText" className="mb4">
        <FormattedMessage {...AUTH.actions.accessDenied.textTitle} />
      </p>
      <If condition={forwardRoute.path !== 'communities'}>
        <Button
          className="db w-100"
          color="primary"
          raised
          type="button"
          onClick={() => browserHistory.push(`/${forwardRoute.path}`)}
        >
          <FormattedMessage {...forwardRoute.name} />
        </Button>
      </If>
    </div>
  );
};

AccessDenied.propTypes = {
  forwardRoute: PropTypes.shape({
    name: PropTypes.object,
    path: PropTypes.string,
  }),
};

AccessDenied.defaultProps = {
  forwardRoute: {
    name: COMMON.myHealthboard,
    path: HEALTHBOARD,
  },
};

export default CSSModules(AccessDenied, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Auth/AccessDenied.jsx